///<reference path="../../../../components/common/payroll.service.ts" />
///<reference path="../../../../components/models/meevo.model.custom.ts"/>
///<reference path="../../../../components/modal/modal.interface.ts"/>
///<reference path="../../../../components/common/security.service.ts"/>
///<reference path="../../../../components/busy/busy.service.ts"/>
///<reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../../../components/common/security.keys.ts"/>


module Meevo.Plugins.Reports {

    import IPayrollEmployee = Meevo.Components.Common.IPayrollEmployee;
    import IPayRollListItem = Meevo.Components.Common.IPayRollListItem;
    import IPayRollYear = Meevo.Components.Common.IPayRollYear;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import BusyService = Meevo.Components.Busy.BusyService;

    interface IRunForItem {
        label: string,
        value: string
    }

    interface IPayRollSelectListItem extends IPayRollListItem {
        label: string;
        dateRange: string;
        serviceRetail: string;
    }

    interface ICOPayRollListItem extends IPayRollListItem {
        storeName: string;
    }

    interface ICOPayrollSelectListItem extends ICOPayRollListItem {
        coDateRange: string;
        payrollType: number;
    }

    interface IReportScope extends ng.IScope {
    }

    interface IModalScope extends ng.IScope {
        close: () => void;
        data: any[];
    }

    function formatDateForRange(dateString: string): string {
        let date = new Date(dateString);

        return `${date.getMonth() + 1}/${date.getDate()}`;
    }

    function getUniquePeriodsForSelect(allPeriods: IPayRollListItem[]): IPayRollSelectListItem[] {

        return allPeriods.reduce((list: IPayRollListItem[], row: IPayRollListItem) => {

            if (!_.find(list, (item: IPayRollListItem) => {
                return item.payrollEndDate === row.payrollEndDate
                    && item.payrollStartDate === row.payrollStartDate
                    && item.payrollPeriodId !== row.payrollPeriodId;
            })
            ) {
                list.push(row);
            }

            return list;
        }, <IPayRollListItem[]>[])
            .sort((a: IPayRollListItem, b: IPayRollListItem) => a.payrollStartDate > b.payrollStartDate ? -1 : a.payrollStartDate < b.payrollStartDate ? 1 : 0)
            .map((row: IPayRollListItem) => {
                return <IPayRollSelectListItem>{
                    ...row,
                    label: `${formatDateForRange(<string>row.payrollStartDate)} - ${formatDateForRange(<string>row.payrollEndDate)} ${row.serviceRetailHeaderCount > 0 ? 'S & R' : row.retailHeaderCount > 0 ? 'R' : 'S'}`,
                    dateRange: moment(row.payrollStartDate).format('ddd ' + moment.localeData().longDateFormat('L')) + ' - ' + moment(row.payrollEndDate).format('ddd ' + moment.localeData().longDateFormat('L')),
                    serviceRetail: `${row.serviceRetailHeaderCount > 0 ? 'S & R' : row.retailHeaderCount > 0 ? 'R' : 'S'}`,
                    StoreName: row.storeName,
                };
            });
    }

    class MeevoReportDe040Component implements angular.IComponentController {

        static $inject = [
            '$q',
            '$scope',
            '$mdDialog',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.PayRollService',
            'meevo.components.common.SecurityService',
        ];

        public payRollEmployees: IPayrollEmployee[] = [];
        public allSelected: boolean;

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: SecurityAccessEnum;
        public options: Model.IReportControl;
        public form: ng.IFormController;
        public criteria: any;

        private _payRollYears: IPayRollYear[] = [];
        private _payrollPeriodSelectList: IPayRollSelectListItem[] = [];
        private _allPayrollPeriods: any[] = [];

        private _selectedRange: string;
        private _filteredList: IPayRollSelectListItem[];

        private _payrollPeriodsCache: { [key: string]: IPayRollListItem[] } = {};

        private _coPayrollPeriods = [];
        public locationsPayroll: any = [];
        public reportId: any;
        public reportCount: number = 0;
        public startDayOfWeek: any;
        public isMLPayrollEnabled: boolean;

        public runForItems: IRunForItem[] = [
            { label: 'LABEL_ONE_PAYROLL_PERIOD', value: 'OnePayrollPeriod' },
            { label: 'LABEL_MULTIPLE_PAYROLL_PERIODS', value: 'MultiplePayrollPeriods' },
        ];

        private _selectedItem: string;

        get selectedItem(): string {
            return this._selectedItem;
        }

        set selectedItem(value: string) {
            this._selectedItem = this.mainModel['runForPeriods'] = value;
            if (value === 'OnePayrollPeriod') {
                if (Model.Guard.isSomething(this._selectedRange))
                    this.mainModel[this.parameterNames[1]][0] = this._selectedRange;
            } else {
                this.filterPeriodsByDate();
            }
        }

        get payRollYears(): IPayRollYear[] {
            return this._payRollYears;
        }

        get payrollPeriodSelectList(): IPayRollSelectListItem[] {
            return this._payrollPeriodSelectList;
        }

        get selectedYear(): IPayRollYear {
            var ret = _.findWhere(this.payRollYears, <IPayRollYear>{ payrollYear: this.mainModel[this.parameterNames[0]] });
            return ret;
        }

        set selectedYear(value: IPayRollYear) {
            this.mainModel[this.parameterNames[0]] = value.payrollYear;
            this.loadPayrollPeriod(value.startOfYear, value.endOfYear);
        }

        get selectedRange(): IPayRollSelectListItem {
            var ret = _.findWhere(this.payrollPeriodSelectList, <IPayRollSelectListItem>{ payrollPeriodId: this._selectedRange });
            return ret;
        }

        set selectedRange(value: IPayRollSelectListItem) {
            if (Model.Guard.isSomething(value)) {
                this._selectedRange = value.payrollPeriodId;

                if (this.mainModel['RunEmployeeCompensationReportInMode'] === 'DetailMode' || this.mainModel['runForPeriods'] === 'OnePayrollPeriod') {
                    this.mainModel[this.parameterNames[1]] = value.payrollPeriodId;
                } else {
                    this.filterPeriodsByDate();
                }

                this.mainModel[this.parameterNames[2]] = [];
                this.mainModel["StartDate"] = value.payrollStartDate;
                this.mainModel["EndDate"] = value.payrollEndDate;

                this.updateCriteria();
            }
        }

        public updateStartEndDates(period: any) {
            if (Model.Guard.isSomething(period)) {
                this.mainModel[this.parameterNames[4]] = period.payrollStartDate;
                this.mainModel[this.parameterNames[5]] = period.payrollEndDate;
                this.updateCriteria();
            }
        }

        public filterPeriodsByDate() {
            this._filteredList = this._allPayrollPeriods
                .filter(period =>
                    moment(period.payrollStartDate).isBetween(this.mainModel[this.parameterNames[4]], this.mainModel[this.parameterNames[5]]) || moment(period.payrollStartDate).startOf('day').isSame(moment(this.mainModel[this.parameterNames[4]]).startOf('day')) || moment(period.payrollStartDate).startOf('day').isSame(moment(this.mainModel[this.parameterNames[5]]).startOf('day'))
                )
            if (this.mainModel['runForPeriods'] === 'MultiplePayrollPeriods' && this.mainModel['RunEmployeeCompensationReportInMode'] === 'SummaryView' || this.options.reportId == 244) {
                if (this._filteredList.length === 0)
                    this.mainModel[this.parameterNames[1]] = ['00000000-0000-0000-0000-000000000000'];
                else
                    this.mainModel[this.parameterNames[1]] = this._filteredList.map(period => period.payrollPeriodId);
            }
            else
                this.mainModel[this.parameterNames[1]] = Model.Guard.isSomething(this.selectedRange) ? this.selectedRange.payrollPeriodId : null;
        }

        get selectedRangeDatesString(): string {
            return <string>this.selectedYear.startOfYear + <string>this.selectedYear.endOfYear;
        }


        get controlInValid(): boolean {
            return (this.mainModel[this.parameterNames[3]] || []).length === 0
        }

        get selectedPayrollPeriodCount(): number {
            return this.reportCount;
        }

        public totalPayrollPeriod() {
            this.reportCount = 0;
            if (this.options.reportId != 244  ) {
                if (Model.Guard.isNothing(this.mainModel[this.parameterNames[1]])) {
                    this.reportCount = 0;
                }
                else if (this.mainModel[this.parameterNames[1]][0] === '00000000-0000-0000-0000-000000000000') {
                    this.reportCount = 0;
                }
                else {
                    if (Array.isArray(this.mainModel[this.parameterNames[1]])) {
                        this.reportCount = (this.mainModel[this.parameterNames[1]].length);
                    }
                    else {
                        this.reportCount = 1;
                    }
                }
            }
            else {
                var nonMLPayrolls = this._coPayrollPeriods.filter(item => item.isMultiLocationPayPeriod == false)
                var mlPayrolls = this._coPayrollPeriods.filter(item => item.isMultiLocationPayPeriod == true)
                
                var countOfNonML = 0;
                var countOfML = 0;

                if (mlPayrolls.length > 0) {
                    var groupLocations = _.groupBy(mlPayrolls, "locationId");

                    _.each(groupLocations, (value: any, key: any) => {
                        countOfML = value.length;
                    });                   
                }
                if (nonMLPayrolls.length > 0) {
                    countOfNonML = nonMLPayrolls.length;
                }

                return this.reportCount = countOfNonML + countOfML;             
            }
            return this.reportCount;
        }

        constructor(private $q: angular.IQService,
            protected $scope: IReportScope,
            protected $mdDialog: ng.material.IDialogService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: BusyService,
            private payRollService: Meevo.Components.Common.PayRollService,
            private securityService: Meevo.Components.Common.ISecurityService) {
            this.criteria = {};

        }

        viewPayrollPeriods() {
            let modalScope: IModalScope = <IModalScope>this.$scope.$new(true);

            modalScope.close = () => {
                this.$mdDialog.cancel();
            };

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/reports/components/de040/meevo-report-de040-modal.html',
                scope: modalScope
            };

            modalScope.data = this.options.reportId == 244 ? this._filteredList : getUniquePeriodsForSelect(this._allPayrollPeriods);

            modalScope.locationsPayroll = this.locationsPayroll;
            modalScope.reportId = this.options.reportId;
            this.modalService.showCustom(options);
            this.busyService.stop();
        }

        private loadPeriodYears() {
            return this.payRollService.getPayRollYears()
                .then(periodYears => this._payRollYears = _.sortBy(periodYears, (period: IPayRollYear) => period.payrollYear * (-1)));
        }

        private loadCOPayrollList() {
            var payrollCriteria: any;
            this.locationsPayroll = [];
            payrollCriteria = {
                MultiStartDate: this.mainModel["MultiStartDate"], MultiEndDate: this.mainModel["MultiEndDate"], locationForHierarchy: this.mainModel["locationForHierarchy"]
            };
            this.reportCount = 0;

            this.payRollService.getPayrollSettings().then((res: any) => {
                this.isMLPayrollEnabled = res.enableMultiLocationPayroll;
            });

            return this.payRollService.getCOPayRollList(payrollCriteria)
                .then((payrollPeriod: IPayRollListItem[]) => {
                    if (payrollPeriod.length == 0) {
                        this.reportCount = 0;
                        this.modalService.alert('LABEL_NO_PAYROLLPERIODS_CODE040', Meevo.Components.Modal.ModalTranslationModes.Translate);
                        return;

                    }
                    _.each(payrollPeriod, (item: IPayRollListItem) => {
                        item.dateRange = moment(item.payrollStartDate).format('ddd ' + moment.localeData().longDateFormat('L')) + ' - ' + moment(item.payrollEndDate).format('ddd ' + moment.localeData().longDateFormat('L')),
                            item.serviceRetail = `${item.payrollTypeEnum == 20063 ? 'SR' : item.payrollTypeEnum == 20057 ? 'R' : 'S'}`;
                    });
                    var groupByLocations = _.groupBy(payrollPeriod, 'locationId');
                    if (Model.Guard.isNothing(this.locationsPayroll)) {
                        this.locationsPayroll = [];
                    }
                    _.each(groupByLocations, (item, i) => {
                        var first = _.first(item);
                        var location = { locationId: first.locationId, storeName: first.storeName, payrollPeriods: item };
                        this.locationsPayroll.push(location);

                    });

                    this._coPayrollPeriods = payrollPeriod;
                    this._allPayrollPeriods = payrollPeriod;
                    this._payrollPeriodSelectList = getUniquePeriodsForSelect(payrollPeriod);

                    this.selectedRange = this._payrollPeriodSelectList[0];
                    this.filterPeriodsByDate();
                    this.totalPayrollPeriod();
                    this.updateCriteria();

                });


        }

        private loadPayrollPeriod(startDate: string | Date, endDate: string | Date) {
            var payrollCriteria :any;
            //DE043 needs only service Payroll

            if (this.options.reportId == 211) {
                payrollCriteria = { StartDate: startDate, EndDate: endDate, retailPayroll: false };
            } else {
                payrollCriteria = { StartDate: startDate, EndDate: endDate };
            }

            return new this.$q(resolve => {
                if (this._payrollPeriodsCache[this.selectedRangeDatesString] instanceof Array) {
                    resolve(this._payrollPeriodsCache[this.selectedRangeDatesString]);
                } else {
                    this.mainModel[this.parameterNames[1]] = null;
                    this._payrollPeriodSelectList = null;
                    return this.payRollService
                        .getPayRollList(payrollCriteria)
                        .then(res => resolve(res));
                }
            }).then((payrollPeriod: IPayRollListItem[]) => {

                this._payrollPeriodsCache[this.selectedRangeDatesString] = this._allPayrollPeriods = payrollPeriod;

                this._payrollPeriodSelectList = getUniquePeriodsForSelect(payrollPeriod);

                this.selectedRange = this._payrollPeriodSelectList[0];
                this.updateStartEndDates(this.selectedRange);
                this.totalPayrollPeriod();

            }

            );
        }

        setWatcher() {
            this.$scope.$watch(() => this.mainModel['RunEmployeeCompensationReportInMode'], (newValue: string, oldValue: string) => {
                if (newValue === 'SummaryView') {
                    this.loadMultiPayrollPeriod(this.mainModel[this.parameterNames[4]], this.mainModel[this.parameterNames[5]]);
                }
            });
        }

        private loadMultiPayrollPeriod(startDate: string | Date, endDate: string | Date) {

            if (this.options.reportId == 244) {
                return;
            }
            var payrollCriteria: any;
            //DE043 needs only service Payroll
            if (this.options.reportId == 211) {
                payrollCriteria = { StartDate: startDate, EndDate: endDate, retailPayroll: false };
            } else {
                payrollCriteria = { StartDate: startDate, EndDate: endDate };
            }

            return this.payRollService
                .getPayRollList(payrollCriteria)
                .then(
                    (payrollPeriod: IPayRollListItem[]) => {
                        if (payrollPeriod.length > 0) {
                            this._allPayrollPeriods = payrollPeriod;
                            this.mainModel[this.parameterNames[1]] = this._allPayrollPeriods
                                .map(period => period.payrollPeriodId);

                            this.mainModel[this.parameterNames[2]] = [];
                            this.mainModel["StartDate"] = startDate;
                            this.mainModel["EndDate"] = endDate;
                            this.updateCriteria();
                            this.filterPeriodsByDate();
                        }
                        else {
                            this._allPayrollPeriods = [];
                            this.filterPeriodsByDate();
                        }
                        this.totalPayrollPeriod();
                    });




        }


        $onInit() {
            this.criteria['reportId'] = this.options.reportId;
            this.securityAccess = SecurityAccessEnum.Deny;
            this.securityService.checkSecurityKey(SecurityKeys.REPORTS_VIEWALLEMPLOYEES_EDIT)
                .then((permission: SecurityAccessEnum) => {
                    this.securityAccess = permission;
                });

            this.selectedItem = this.runForItems[0].value;
            this.loadPeriodYears();
            this.setWatcher();
        }

        updateCriteria() {
            if (this.options.reportId == 244) {
                if (Model.Guard.isSomething(this.mainModel["locationForHierarchy"]) && this.mainModel["locationForHierarchy"].length > 0) {
                    angular.extend(this.criteria,
                        {
                            PayrollPeriodList_TBL: _.pluck(this._coPayrollPeriods, 'payrollPeriodId'),
                            LocationForHierarchy: this.mainModel["locationForHierarchy"]
                        });
                } else {
                    this.reportCount = 0;
                }
            }
            else
            {
                angular.extend(this.criteria, {
                    PayrollPeriodList_TBL: this.mainModel[this.parameterNames[1]],
                    LocationForHierarchy: this.mainModel["locationForHierarchy"],
                    StartDate: this.mainModel[this.parameterNames[4]],
                    EndDate: this.mainModel[this.parameterNames[5]]
                });

            }

        }
        updatePayrollSelect() {
            if (this.mainModel['RunEmployeeCompensationReportInMode'] === 'DetailMode' || this.mainModel['runForPeriods'] === 'OnePayrollPeriod') {

                this.updateCriteria();
            }
            if (this.mainModel['RunEmployeeCompensationReportInMode'] === 'DetailMode' || this.mainModel['runForPeriods'] === 'MultiplePayrollPeriods') {
                this._allPayrollPeriods = [];
                if (Model.Guard.isNothing(this.mainModel[this.parameterNames[4]])) {
                    this.mainModel[this.parameterNames[4]] = moment().toDate();
                }
                if (Model.Guard.isNothing(this.mainModel[this.parameterNames[5]])) {
                    this.mainModel[this.parameterNames[5]] = moment().toDate();
                }
                this.loadMultiPayrollPeriod(this.mainModel[this.parameterNames[4]], this.mainModel[this.parameterNames[5]])

            }

        }
        checkForCODE040Select(reportId: any) {
            if (reportId == 244) {
                this.mainModel['runForPeriods'] = 'MultiplePayrollPeriods';
                this.updatePayrollSelect();
            }

        }
    }


    angular.module('meevo.plugins.reports')
        .component('meevoReportDe040Component', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/de040/meevo-report-de040.component.html',
            controller: MeevoReportDe040Component,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                options: '<',
                form: '<',
                startDayofWeek: '=?',
            }
        });
}
